// src/api/audience.js
import apiClient from './client';

// Get all audiences
export const getAllAudiences = async () => {
  try {
    const response = await apiClient.get('/audience');
    return response.data;
  } catch (error) {
    console.error('Failed to get audiences:', error);
    throw error;
  }
};

// Get a single audience by ID
export const getAudienceById = async (audienceId) => {
  try {
    const response = await apiClient.get(`/audience/${audienceId}`);
    return response.data;
  } catch (error) {
    console.error(`Failed to get audience ${audienceId}:`, error);
    throw error;
  }
};

// Update an audience
export const updateAudience = async (audience) => {
  try {
    const audienceId = audience.audience_id || audience.id;
    
    if (!audienceId) {
      throw new Error('Audience ID is required for updates');
    }
    
    console.log(`Sending PATCH request to /audience/${audienceId} with data:`, audience);
    
    // Use PATCH endpoint for update
    const response = await apiClient.patch(`/audience/${audienceId}`, audience);
    
    console.log('Update response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Failed to update audience:', error);
    throw error;
  }
};

// Delete an audience
export const deleteAudience = async (audienceId) => {
  try {
    const response = await apiClient.delete(`/audience/${audienceId}`);
    return response.data;
  } catch (error) {
    console.error(`Failed to delete audience ${audienceId}:`, error);
    throw error;
  }
};

// Preview an audience
export const previewAudience = async (filterCriteria) => {
  try {
    const response = await apiClient.post('/audience/preview', filterCriteria);
    return response.data;
  } catch (error) {
    console.error('Failed to preview audience:', error);
    throw error;
  }
};

// Get audience fields
export const getAudienceFields = async () => {
  try {
    const response = await apiClient.get('/audience/fields');
    return response.data;
  } catch (error) {
    console.error('Failed to get audience fields:', error);
    throw error;
  }
};

// Get audience operators
export const getAudienceOperators = async (fieldType = null) => {
  try {
    let url = '/audience/operators';
    
    // Only add the query parameter if fieldType is a string
    if (fieldType && typeof fieldType === 'string') {
      url += `?field_type=${encodeURIComponent(fieldType)}`;
    }
    
    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    console.error('Failed to get audience operators:', error);
    // Return some default operators so the UI doesn't break
    return [
      { value: 'EQUALS', label: 'equals', appliesTo: ['text', 'number', 'date', 'boolean', 'select'] },
      { value: 'NOT_EQUALS', label: 'does not equal', appliesTo: ['text', 'number', 'date', 'boolean', 'select'] },
      { value: 'CONTAINS', label: 'contains', appliesTo: ['text'] },
      { value: 'NOT_CONTAINS', label: 'does not contain', appliesTo: ['text'] },
      { value: 'GREATER_THAN', label: 'greater than', appliesTo: ['number', 'date'] },
      { value: 'LESS_THAN', label: 'less than', appliesTo: ['number', 'date'] }
    ];
  }
};

// Create a new audience
export const createAudience = async (audienceData) => {
  try {
    const response = await apiClient.post('/audience/save', audienceData);
    return response.data;
  } catch (error) {
    console.error('Failed to create audience:', error);
    throw error;
  }
};

// Load audience conditions
export const loadAudienceConditions = async (audienceId) => {
  try {
    const response = await apiClient.get(`/audience/conditions/${audienceId}`);
    return response.data;
  } catch (error) {
    console.error(`Failed to load conditions for audience ${audienceId}:`, error);
    throw error;
  }
};

// Validate audience filter criteria
export const validateAudienceFilters = async (filterCriteria) => {
  try {
    const response = await apiClient.post('/audience/validate', filterCriteria);
    return response.data;
  } catch (error) {
    console.error('Failed to validate audience filters:', error);
    throw error;
  }
};

export const previewComplexFilter = async (slug) => {
  try {
    const response = await apiClient.get(`/complex-filters/${slug}/preview`);
    return response.data;
  } catch (error) {
    console.error('Failed to preview complex filter:', error);
    throw error;
  }
};